var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInPersonSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6BFFA887-AF82-440D-8936-490FEDF708F1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E99EF9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE53E4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-Finished-Tentative-2b-In-Person",
    transform: "translate(-775, -514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(543, 277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(104, 237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-inPersonSession",
    transform: "translate(128, 0.9102)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2186109,7.70177072 C10.4986589,7.02614567 10.1779804,6.25141955 9.50235535,5.97137151 C8.8267303,5.69132346 8.05200419,6.01200198 7.77195614,6.68762703 C7.4919081,7.36325208 7.81258662,8.1379782 8.48821167,8.41802624 C9.16383672,8.69807429 9.93856283,8.37739577 10.2186109,7.70177072 Z M12.307563,9.51271637 C11.8161156,10.5642953 10.8569051,12.1179795 9.01072088,14.3454795 C7.12190509,12.0706111 6.14966825,10.5027164 5.64519456,9.44876901 C5.43878799,9.08923621 5.29239314,8.69844995 5.21177351,8.29179532 C5.15637526,8.09105423 5.1327994,7.8828674 5.14190509,7.67482164 C5.14190509,7.62982164 5.14190509,7.58600585 5.14190509,7.54100585 C5.1429442,5.91531079 6.1641324,4.46514373 7.69437773,3.91629518 C9.22462306,3.36744662 10.9347088,3.83799576 11.9687585,5.09243861 C13.0028081,6.34688146 13.1383563,8.11533743 12.307563,9.51271637 L12.307563,9.51271637 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInPersonSession);
export default __webpack_public_path__ + "static/media/icon-inPersonSession.8830e5578ddfbbbc4ae2d6990186bedb.svg";
export { ForwardRef as ReactComponent };